import { css } from 'styled-components';

const colors = {
  mainError: '#ff0000',
  purple: '#6610f2',

  disableButton: '#b2000c',

  contentRemoveHighlight: '#ffc5c6',

  // comparison increase/decrease colors
  warningRed: '#ff3b30',
  normalGreen: '#34c759',
  hoverGreen: '#CCE0DD',

  favoriteGoldTitle: '#ffb931',

  backgroundRed: '#ffeef0ff',
  backgroundGreen: '#eefaf5ff',

  warningBanner: '#fec351',
};

const layout = {
  headerHeight: 56,
  mainContainerHorizontalPadding: 24,
  sidebarWidth: 240,
  channelHeaderHeight: 60,
  collaborationWidth: 360,
  // need at least 950px to display 4 slices in a row.
  sliceContainerMinWidth: 950,
  // default padding for intercom which setup in their platform, need to set it back to default
  // when unmounting the workspace page
  intercomPadding: 20,
  containerBorderRadius: 8,
};

const getScrollBarStyles = (width: number) => css`
  &::-webkit-scrollbar {
    width: ${width}px !important;
    height: ${width}px !important;
    border-radius: ${width}px !important;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.4);
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2 !important;
  }
`;

export { colors, layout, getScrollBarStyles };
